import { useSelector } from 'react-redux';

import { selectIsLimitsModalOpen } from '~/components/account/ducks';
import LimitsModal from '~/components/limits/modal';
import { NotificationsWrapper } from '~/components/notifications/notifications';
import Notifications from '~/components/notifications/notifications-container.js';
import NotificationsQueueContainer from '~/components/notifications/notifications-queue-container';
import useUIContext from '~/ui/use-ui-context';

const SidebarCommon = () => {
	const { hasStaticHeader, withinSidebar } = useUIContext();
	const showLimitsModal = useSelector(selectIsLimitsModalOpen);

	return (
		<>
			<NotificationsWrapper
				withinSidebar={withinSidebar}
				hasStaticHeader={hasStaticHeader}
				className="notifications-wrapper"
			>
				<Notifications />
				<NotificationsQueueContainer />
			</NotificationsWrapper>
			{showLimitsModal && <LimitsModal />}
		</>
	);
};

export default SidebarCommon;
